// pages/qrcode/BarcodeEdit.js
import React, { useState, useEffect, useContext } from "react"
import { useParams, useNavigate } from "react-router-dom"
import api from "../../services/api"
import { UserContext } from "../../context/UserContext"

function BarcodeEdit() {
  console.log("[BARCODEEDIT] Rendering")
  const { id } = useParams()
  const navigate = useNavigate()
  const { userData } = useContext(UserContext)
  const [barcode, setBarcode] = useState(null)
  const [name, setName] = useState("")
  const [sites, setSites] = useState([])
  const [siteId, setSiteId] = useState("")
  const [questionnaires, setQuestionnaires] = useState([])
  const [questionnaireId, setQuestionnaireId] = useState("")
  const [receivers, setReceivers] = useState([])
  const [newReceiver, setNewReceiver] = useState("")

  useEffect(() => {
    console.log("[BARCODEEDIT] useEffect start", userData)
    loadBarcode()
    loadSites()
    loadQuestionnaires()
  }, [])

  const loadBarcode = async () => {
    console.log("[BARCODEEDIT] loadBarcode")
    try {
      const res = await api.get(`/barcode/details/${id}`)
      setBarcode(res.data.barcode)
      setName(res.data.barcode.name || "")
      setSiteId(res.data.barcode.site ? res.data.barcode.site._id : "")
      setQuestionnaireId(res.data.barcode.questionnaireId || "")
      setReceivers(res.data.barcode.receivers || [])
    } catch (err) {
      console.log("[BARCODEEDIT] loadBarcode error", err)
      alert("Error loading barcode")
    }
  }

  const loadSites = async () => {
    console.log("[BARCODEEDIT] loadSites")
    try {
      const res = await api.get("/site/all")
      setSites(res.data.sites || [])
    } catch (err) {
      console.log("[BARCODEEDIT] loadSites error", err)
    }
  }

  const loadQuestionnaires = async () => {
    console.log("[BARCODEEDIT] loadQuestionnaires")
    try {
      const res = await api.get("/questionnaires/list")
      setQuestionnaires(res.data.questionnaires || [])
    } catch (err) {
      console.log("[BARCODEEDIT] loadQuestionnaires error", err)
    }
  }

  const handleAddReceiver = () => {
    console.log("[BARCODEEDIT] handleAddReceiver")
    if (newReceiver.trim()) {
      setReceivers([...receivers, newReceiver.trim()])
      setNewReceiver("")
    }
  }

  const handleRemoveReceiver = (index) => {
    console.log("[BARCODEEDIT] handleRemoveReceiver")
    const updated = [...receivers]
    updated.splice(index, 1)
    setReceivers(updated)
  }

  const handleSave = async () => {
    console.log("[BARCODEEDIT] handleSave")
    if (!name || !siteId) {
      alert("Missing fields")
      return
    }
    try {
      const body = {
        name,
        siteId,
        questionnaireId,
        receivers
      }
      await api.put(`/barcode/update/${id}`, body)
      alert("Barcode updated")
      navigate("/app/qrcode")
    } catch (err) {
      console.log("[BARCODEEDIT] handleSave error", err)
      alert("Error updating barcode")
    }
  }

  const handleDelete = async () => {
    console.log("[BARCODEEDIT] handleDelete")
    if (!window.confirm("Are you sure you want to delete this barcode?")) return
    try {
      await api.delete(`/barcode/delete/${id}`)
      alert("Barcode deleted")
      navigate("/app/qrcode")
    } catch (err) {
      console.log("[BARCODEEDIT] handleDelete error", err)
      alert("Error deleting barcode")
    }
  }

  if (!barcode) {
    return <div>Loading...</div>
  }

  return (
    <div>
      <h2>Edit Barcode</h2>
      <div>
        <label>Name</label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Barcode Name"
        />
      </div>
      <div>
        <label>Site</label>
        <select value={siteId} onChange={(e) => setSiteId(e.target.value)}>
          <option value="">Select Site</option>
          {sites.map((site) => (
            <option key={site._id} value={site._id}>
              {site.plainName} - {site.address}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label>Questionnaire (Optional)</label>
        <select
          value={questionnaireId}
          onChange={(e) => setQuestionnaireId(e.target.value)}
        >
          <option value="">None</option>
          {questionnaires.map((q) => (
            <option key={q._id} value={q._id}>
              {q.name}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label>Receivers</label>
        <div style={{ marginBottom: "5px" }}>
          <input
            type="email"
            value={newReceiver}
            onChange={(e) => setNewReceiver(e.target.value)}
            placeholder="Enter new receiver email"
          />
          <button onClick={handleAddReceiver} style={{ marginLeft: "5px" }}>
            +
          </button>
        </div>
        <ul>
          {receivers.map((email, index) => (
            <li key={index}>
              {email}
              <button
                onClick={() => handleRemoveReceiver(index)}
                style={{ marginLeft: "10px" }}
              >
                Remove
              </button>
            </li>
          ))}
        </ul>
      </div>
      <button onClick={handleSave} style={{ marginRight: "10px" }}>
        Save
      </button>
      <button onClick={handleDelete}>Delete Barcode</button>
    </div>
  )
}

export default BarcodeEdit